import http from '@/plugins/axios/axios';

export default class MensagemService {

    salvar(requisicao) {        
        return http.post('/api/adm/mensagem/salvar', requisicao);
    }

    alterar(id, requisicao) {        
        return http.put('/api/adm/mensagem/alterar/'+id, requisicao);
    }

    excluir(id) {        
        return http.delete('/api/adm/mensagem/excluir/'+id);
    }

    listarTodos() {        
        return http.get('/api/adm/mensagem/listar');
    }

    listar(ano, mes) {        
        return http.get('/api/adm/mensagem/listar/'+ano+'/'+mes);
    }
}